import { Button } from "@material-ui/core";
import React from "react";

export const IconButton = ({ icon, label, color, onClick, className }) => (
  <Button variant="contained" color={color || "primary"} startIcon={icon} onClick={onClick} className={className}>
    {label}
  </Button>
);
